import React from 'react';
import { AnalyticsErrorBoundary } from './AnalyticsErrorBoundary';
import { useIsMobile } from '../../../hooks/useIsMobile';

interface AnalyticsDashboardProps<TFilters> {
  filters: TFilters;
  metricsComponent: React.ComponentType<{ filters: TFilters }>;
  cards: Array<React.ComponentType<{ filters: TFilters }>>;
  className?: string;
  spacing?: 'tight' | 'normal' | 'loose';
  gridColumns?: 1 | 2 | 3;
}

const spacingClasses = {
  tight: 'space-y-4',
  normal: 'space-y-6',
  loose: 'space-y-8',
};

export function AnalyticsDashboard<TFilters>({
  filters,
  metricsComponent: MetricsComponent,
  cards,
  className = '',
  spacing = 'normal',
  gridColumns = 2,
}: AnalyticsDashboardProps<TFilters>) {
  const isNarrow = useIsMobile(1024);
  const colMap: Record<1 | 2 | 3, string> = { 1: 'grid-cols-1', 2: 'grid-cols-2', 3: 'grid-cols-3' };
  const colClass = isNarrow ? 'grid-cols-1' : colMap[gridColumns];
  return (
    <AnalyticsErrorBoundary>
      <div className={`w-full ${spacingClasses[spacing]} ${className}`}>
        <MetricsComponent filters={filters} />
        <div className={`grid ${colClass} ${isNarrow ? 'gap-4' : 'gap-6'}`}>
          {cards.map((Card, index) => (
            <Card key={index} filters={filters} />
          ))}
        </div>
      </div>
    </AnalyticsErrorBoundary>
  );
}
